import { client } from "utils";

export const getRolesRequest = () => client.get("roles");

export const getRolesAllRequest = () => client.get("roles-all");
